"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DashboardLayoutItem = void 0;
var tslib_1 = require("tslib");
var DashboardLayoutItemRenderer_1 = require("./DashboardLayoutItemRenderer");
var DashboardLayoutWidgetRenderer_1 = require("./DashboardLayoutWidgetRenderer");
function DashboardLayoutItem(props) {
    var item = props.item, _a = props.itemRenderer, itemRenderer = _a === void 0 ? DashboardLayoutItemRenderer_1.DashboardLayoutItemRenderer : _a, widgetRenderer = props.widgetRenderer, screen = props.screen;
    var renderProps = { item: item, screen: screen, DefaultWidgetRenderer: DashboardLayoutWidgetRenderer_1.DashboardLayoutWidgetRenderer };
    return itemRenderer(tslib_1.__assign(tslib_1.__assign({}, props), { DefaultItemRenderer: DashboardLayoutItemRenderer_1.DashboardLayoutItemRenderer, children: widgetRenderer(renderProps) }));
}
exports.DashboardLayoutItem = DashboardLayoutItem;
//# sourceMappingURL=DashboardLayoutItem.js.map